import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../Pages/CommonAppRedux/Auth/authSlice";

import layoutReducer from "../Pages/CommonAppRedux/Layout/layoutSlice";
import tabsValueReducer from "../Pages/CommonAppRedux/TabsValue/tabsValueSlice";
import docNumberingSlice from "../Pages/CommonAppRedux/DocNumbering/docNumberingSlice";
import commonApiCallReducer from "../Pages/CommonAppRedux/CommonApiCall/commonApiCallSlice";
import shortcutItemReducer from "../Pages/CommonAppRedux/ShortcutRedux/shortcutItemSlice";

// core App setup
import organizationReducer from "../Pages/CoreSetupApp/Organization/Redux/organizationSlice";
import branchPermissionReducer from "../Pages/CoreSetupApp/BranchPermission/Redux/branchPermissionSlice";
import roleReducer from "../Pages/CoreSetupApp/Role/Redux/roleSlice";
import branchRoleReducer from "../Pages/CoreSetupApp/BranchRole/Redux/branchRoleSlice";
import branchReducer from "../Pages/CoreSetupApp/Branch/Redux/branchSlice";
import provinceReducer from "../Pages/CoreSetupApp/Province/Redux/provinceSlice";
import districtReducer from "../Pages/CoreSetupApp/District/Redux/districtSlice";
import palikaReducer from "../Pages/CoreSetupApp/Palika/Redux/palikaSlice";
import userGroupReducer from "../Pages/CoreSetupApp/UserGroup/Redux/userGroupSlice";
import userReducer from "../Pages/CoreSetupApp/User/Redux/userSlice";
import departmentReducer from "../Pages/CoreSetupApp/Department/Redux/departmentSlice";
import countryReducer from "../Pages/CoreSetupApp/Country/Redux/countrySlice";
import baseDocRuleReducer from "../Pages/CoreSetupApp/BaseDocRule/Redux/baseDocRuleSlice";
import currencyReducer from "../Pages/CoreSetupApp/Currency/Redux/currencySlice";
import areaReducer from "../Pages/CoreSetupApp/Area/Redux/areaSlice";
import documentNumberingReducer from "../Pages/CoreSetupApp/DocumentNumbering/Redux/documentNumberingSlice";
import documentSeriesReducer from "../Pages/CoreSetupApp/DocSeries/Redux/documentSeriesSlice";
import wardReducer from "../Pages/CoreSetupApp/Ward/Redux/wardSlice";
import freightReducer from "../Pages/CoreSetupApp/Freight/Redux/freightSlice";

// import systemSelectionReducer from "../Pages/CommonAppRedux/SystemSelection/systemSelectionSlice";
import paginationReducer from "../Pages/CommonAppRedux/Pagination/paginationSlice";

import notificationReducer from "../Pages/CommonAppRedux/Notification/notificationSlice";

// item reducers
import itemReducer from "../Pages/Inventory/Item/Redux/itemSlice";

// cost center type
import dimensionReducer from "../Pages/CostCenterType/Dimension/Redux/dimensionSlice";
import costCenterTypeReducer from "../Pages/CostCenterType/CostCenterType/Redux/costCenterTypeSlice";
import costCenterReducer from "../Pages/CostCenterType/CostCenter/Redux/costCenterSlice";
// party reducers
import customerReducer from "../Pages/Inventory/Customer/Redux/customerSlice";

import supplierReducer from "../Pages/Inventory/Supplier/Redux/supplierSlice";

// purchase
// Interbranch
import materialRequestReducer from "../Pages/Inventory/MaterialRequest/Redux/materialRequestSlice";
import purchaseInvoiceBranchReducer from "../Pages/Inventory/PurchaseAP/Interbranch/PurchaseInvoiceBranch/Redux/purchaseInvoiceBranchSlice";
import purchaseReturnBranchReducer from "../Pages/Inventory/PurchaseAP/Interbranch/PurchaseReturnBranch/Redux/purchaseReturnBranchSlice";
import purchaseOrderBranchReducer from "../Pages/Inventory/PurchaseAP/Interbranch/PurchaseOrderBranch/Redux/purchaseOrderBranchSlice";
// Third party AP
import purchaseOrderReducer from "../Pages/Inventory/PurchaseAP/ThirdPartyAP/PurchaseOrder/Redux/purchaseOrderSlice";
import purchaseInvoiceReducer from "../Pages/Inventory/PurchaseAP/ThirdPartyAP/PurchaseInvoice/Redux/purchaseInvoiceSlice";
import grnReducer from "../Pages/Inventory/PurchaseAP/ThirdPartyAP/GRN/Redux/grnSlice";
import grnInvoiceReducer from "../Pages/Inventory/PurchaseAP/ThirdPartyAP/GrnInvoice/Redux/grnInvoiceSlice";
import purchaseReturnReducer from "../Pages/Inventory/PurchaseAP/ThirdPartyAP/PurchaseReturn/Redux/purchaseReturnSlice";
import purchaseDebitNoteReducer from "../Pages/Inventory/PurchaseAP/ThirdPartyAP/PurchaseDebitNote/Redux/purchaseDebitNoteSlice";
import purchaseCreditNoteReducer from "../Pages/Inventory/PurchaseAP/ThirdPartyAP/PurchaseCreditNote/Redux/purchaseCreditNoteSlice";

// sale reduceres

// Interbarnch
import saleOrderRequestReducer from "../Pages/Inventory/SaleAR/Interbranch/SaleOrderRequest/Redux/saleOrderRequestSlice";
import saleInvoiceBranchReducer from "../Pages/Inventory/SaleAR/Interbranch/SaleInvoiceBranch/Redux/saleInvoiceBranchSlice";
import saleReturnBranchReducer from "../Pages/Inventory/SaleAR/Interbranch/SaleReturnBranch/Redux/saleReturnBranchSlice";
import saleOrderBranchReducer from "../Pages/Inventory/SaleAR/Interbranch/SaleOrderBranch/Redux/saleOrderBranchSlice";
// Third party a/r

import saleOrderReducer from "../Pages/Inventory/SaleAR/ThirdPartyAR/SaleOrder/Redux/saleOrderSlice";
import deliveryNoteReducer from "../Pages/Inventory/SaleAR/ThirdPartyAR/DeliveryNote/Redux/deliveryNoteSlice";
import saleInvoiceReducer from "../Pages/Inventory/SaleAR/ThirdPartyAR/SaleInvoice/Redux/saleInvoiceSlice";

import saleReturnReducer from "../Pages/Inventory/SaleAR/ThirdPartyAR/SaleReturn/Redux/saleReturnSlice";
import saleDebitNoteReducer from "../Pages/Inventory/SaleAR/ThirdPartyAR/SaleDebitNote/Redux/saleDebitNoteSlice";
import saleCreditNoteReducer from "../Pages/Inventory/SaleAR/ThirdPartyAR/SaleCreditNote/Redux/saleCreditNoteSlice";

import saleReducer from "../Pages/Inventory/Sale/Redux/saleSlice";
// accounting reducer
import glAccountReducer from "../Pages/Accounting/GLAccount/Redux/glAccountSlice";
import voucherModeReducer from "../Pages/Accounting/VoucherMode/Redux/voucherModeSlice";
import accountGroupReducer from "../Pages/Accounting/GLAccountGroup/Redux/accountGroupSlice";
import voucherReducer from "../Pages/Accounting/Voucher/Redux/voucherSlice";
import costCenterReportReducer from "../Pages/Accounting/CostCenterReport/Redux/costCenterReportSlice";
import paymentVoucherReducer from "../Pages/Accounting/PaymentVoucher/Redux/paymentVoucherSlice";
import reciptVoucherReducer from "../Pages/Accounting/ReciptVoucher/Redux/reciptVoucherSlice"; 

// import accountGroupReducer from "../Pages/Accounting/GlAccountGroup/Redux/accountGroupSlice";
// dashboard reducer
import dashboardReducer from "../Pages/Dashboard/Redux/dashboardSlice";

// product common pages
import baseUnitReducer from "../Pages/CommonPages/BaseUnit/Redux/baseUnitSlice";
import brandReducer from "../Pages/CommonPages/Brand/Redux/brandSlice";
import categoryReducer from "../Pages/CommonPages/Category/Redux/categorySlice";
import colourReducer from "../Pages/CommonPages/Colour/Redux/colourSlice";
import companyReducer from "../Pages/CommonPages/Company/Redux/companySlice";
import divisionReducer from "../Pages/CommonPages/Division/Redux/divisionSlice";
import flavourReducer from "../Pages/CommonPages/Flavour/Redux/flavourSlice";
import groupsReducer from "../Pages/CommonPages/Groups/Redux/groupsSlice";
import productTypeReducer from "../Pages/CommonPages/ProductType/Redux/productTypeSlice";
import shapeReducer from "../Pages/CommonPages/Shape/Redux/shapeSlice";
import customerTypeReducer from "../Pages/CommonPages/CustomerType/Redux/customerTypeSlice";
import paymentTypeReducer from "../Pages/CommonPages/PaymentType/Redux/paymentTypeSlice";
import paymentModeReducer from "../Pages/CommonPages/PaymentMode/Redux/paymentModeSlice";
import grnAdditionalCostReducer from "../Pages/AdditionalCost/GrnAdditionalCost/Redux/grnAdditionalCostSlice";
import additionalChargeReducer from "../Pages/AdditionalCost/AdditionalCharge/Redux/additionalChargeSlice";
import grnChargeStatusReducer from "../Pages/AdditionalCost/GrnChargeStatus/Redux/grnChargeStatusSlice";
import voucherTypeReducer from "../Pages/Accounting/VoucherType/Redux/voucherTypeSlice";

// stock
import stockAnalysisReducer from "../Pages/Stock/StockAnalysis/Redux/stockAnalysisSlice";
import apiLogsReducer from "../Pages/ApiLogs/Redux/apiLogsSlice";

// vehicle
import partyDetailsReducer from "../Components/Modal/PartyDetailsModal/partyDetailsSlice";

// reporting
import ledgerReportReducer from "../Pages/AccountingReport/Ledger/Redux/ledgerSlice";
import productLedgerReportReducer from "../Pages/AccountingReport/Product/Redux/productLedgerSlice";

const rootReducer = combineReducers({
  // commonApp: CommonAppSlice,
  auth: authReducer,
  layout: layoutReducer,
  tabsValue: tabsValueReducer,
  // systemSelection: systemSelectionReducer,
  pagination: paginationReducer,
  notification: notificationReducer,

  shortcutItem: shortcutItemReducer,
  docNumbering: docNumberingSlice,
  commonApiCall: commonApiCallReducer,

  // core Setup
  organization: organizationReducer,
  branchPermission: branchPermissionReducer,
  role: roleReducer,
  branchRole: branchRoleReducer,
  branch: branchReducer,
  country: countryReducer,
  baseDocRule: baseDocRuleReducer,
  currency: currencyReducer,
  province: provinceReducer,
  district: districtReducer,
  palika: palikaReducer,
  ward: wardReducer,
  area: areaReducer,
  documentNumbering: documentNumberingReducer,
  documentSeries: documentSeriesReducer,
  freight: freightReducer,

  user: userReducer,
  userGroup: userGroupReducer,
  department: departmentReducer,

  // item reducer
  item: itemReducer,
  category: categoryReducer,

  // cost center type reducer
  dimension: dimensionReducer,
  costCenterType: costCenterTypeReducer,
  costCenter: costCenterReducer,
  // party reducer
  customer: customerReducer,
  supplier: supplierReducer,

  // accounting Reducer
  glAccount: glAccountReducer,
  voucherMode: voucherModeReducer,
  accountGroup: accountGroupReducer,
  voucher: voucherReducer,
  costCenterReport: costCenterReportReducer,
  paymentVoucher: paymentVoucherReducer,
  reciptVoucher: reciptVoucherReducer, // using same reducer for recipt voucher

  // purchase reducer
  materialRequest: materialRequestReducer,
  purchaseInvoiceBranch: purchaseInvoiceBranchReducer,
  purchaseOrderBranch: purchaseOrderBranchReducer,
  purchaseReturnBranch: purchaseReturnBranchReducer,
  purchaseOrder: purchaseOrderReducer,
  purchaseInvoice: purchaseInvoiceReducer,
  grn: grnReducer,
  grnInvoice: grnInvoiceReducer,
  purchaseReturn: purchaseReturnReducer,
  purchaseDebitNote: purchaseDebitNoteReducer,
  purchaseCreditNote: purchaseCreditNoteReducer,

  // sale reducer
  // interbarnch
  saleOrderRequest: saleOrderRequestReducer,
  saleInvoiceBranch: saleInvoiceBranchReducer,
  saleReturnBranch: saleReturnBranchReducer,
  //third party a/r
  // thirdPArtyAR: thirdPartyARReducer,
  saleOrder: saleOrderReducer,
  saleOrderBranch: saleOrderBranchReducer,
  deliveryNote: deliveryNoteReducer,
  saleReturn: saleReturnReducer,
  saleInvoice: saleInvoiceReducer,
  sale: saleReducer,
  saleDebitNote: saleDebitNoteReducer,
  saleCreditNote: saleCreditNoteReducer,

  // dashboard reducer
  dashboard: dashboardReducer,

  // common product
  baseUnit: baseUnitReducer,
  brand: brandReducer,
  category: categoryReducer,
  colour: colourReducer,
  company: companyReducer,
  division: divisionReducer,
  flavour: flavourReducer,
  groups: groupsReducer,
  productType: productTypeReducer,
  shape: shapeReducer,
  customerType: customerTypeReducer,
  paymentMode: paymentModeReducer,
  paymentType: paymentTypeReducer,
  voucherType: voucherTypeReducer,

  // additional charge
  grnAdditionalCost: grnAdditionalCostReducer,
  additionalCharge: additionalChargeReducer,
  grnChargeStatus: grnChargeStatusReducer,

  // stock
  stockAnalysis: stockAnalysisReducer,
  // api logs
  apiLogs: apiLogsReducer,
  // vehicle details
  partyDetail: partyDetailsReducer,

  // ledger reporting
  ledger: ledgerReportReducer,
  productLedger: productLedgerReportReducer,
});

export default rootReducer;
